export enum Gender {
  'PREFER_NOT_TO_SAY' = 'PREFER_NOT_TO_SAY',
  'WOMAN' = 'WOMAN',
  'MAN' = 'MAN',
  'NON_BINARY' = 'NON_BINARY',
}
